import dayjs from 'dayjs'
const $str = window.$str;

const chartColors = ['#4960FF', '#0CD5FF', '#2DFFAA', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A']
const lineColor = "#eee"; // 图表splitLine的颜色，参考收益统计图
const textColor = "#999"; // 图表文字的颜色，参考收益统计图
const segmentsColorMap = {
  inSum: '#BFE0FF',
  inSharp: '#3EFFB9',
  inPeak: '#89FB3C',
  inFlat: '#2CD095',
  inValley: '#30C43D',
  inDeepValley: '#A8FFA1',

  outSum: '#FFD6C1',
  outSharp: '#3B58FF',
  outPeak: '#528DFF',
  outFlat: '#00A2FF',
  outValley: '#5DAFED',
  outDeepValley: '#B2DDFF',
}

export function getChartOption(incomeModel, chartData = []) {
  const { yMin, yMax } = getYaxisRange(chartData);
  const option = {
    // color: chartColors,
    grid: {
      left: "1%",
      right: "1%",
      top: "15%",
      bottom: "10%",
      containLabel: true // 确保标签不被裁剪
    },
    title: {
      show: false,
      textStyle: {
        fontFamily: 'HarmonyOS Sans SC', // 参考收益统计图，使用HarmonyOS字体
        // color: "#c3c3c3",
        color: textColor,
        fontSize: 16
      },
      text: $str.getKey('收益管理/电量统计图'),
      x: "0%"
    },
    xAxis: {
      type: 'category',
      nameTextStyle: {
        color: textColor
      },
      axisLabel: {
        color: textColor,
      },
      axisTick: {
        show: false // 参考收益统计图，隐藏刻度
      },
      axisLine: { // 坐标轴轴线的配置
        show: false,
        // onZero: true, // 轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
        lineStyle: {
          color: lineColor
        }
      },
      data: chartData.map(it => it.time),
    },
    yAxis: {
        type: 'value',
        name: $str.getKey('收益管理/电量(kWh)'),
        nameTextStyle: {
          fontFamily: 'HarmonyOS Sans SC', // 参考收益统计图，使用HarmonyOS字体
          color: textColor,
          align: 'center',
          padding: [0, 0, 0, 0] // 参考收益统计图
        },
        // nameLocation: 'end',
        max: yMax,
        min: yMin,
        splitLine: {
          lineStyle: {
            color: lineColor,
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor, // 使用 #999
          formatter: '{value}' // 参考收益统计图的格式
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: lineColor
          }
        },
        splitNumber: 6 // 设置Y轴默认分割5个段
    },
    series: createSeries(incomeModel, chartData),
    legend: {
      top: "0%",
      right: "-10%",
      
      icon: "circle",
      itemWidth: 20,
      width: "100%",
      textStyle: {
        fontFamily: 'PingFang H', // 参考收益统计图，使用HarmonyOS字体
        color: '#ABABAB',
        fontSize: 12,
        fontWeight: 300
      }
    },
    tooltip: createTooltip(),
    // tooltip: {
    //   trigger: "axis",
    //   axisPointer: {
    //     type: "shadow"
    //   }
    // },
    axisPointer: {
      link: { xAxisIndex: 'all' }, // 鼠标指示器-辅助线，对所有坐标系生效
      label: {
        backgroundColor: '#777' // 鼠标指示器-坐标文字提示的颜色
      }
    },
    dataZoom: [
      {
        show: true,
        type: 'inside',
      }
    ],
  }

  return option
}


function getYaxisRange(chartData) {
  const result = {
    yMin: 0,
    yMax: 1000,
  }
  if (Array.isArray(chartData) && chartData.length > 0) {
    result.yMax = undefined;
    result.yMin = undefined;
  }
  return result;
}


function createSeries(incomeModel, chartData = []) {
  let series = [];
  if (incomeModel === 1) {
    series = [
      // 放电 ------
      {
        name: $str.getKey('收益管理/放电') + '（' + $str.getKey('收益管理/尖') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/放电'),
        color: segmentsColorMap.outSharp,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.outSharp),
      },
      {
        name: $str.getKey('收益管理/放电') + '（' + $str.getKey('收益管理/峰') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/放电'),
        color: segmentsColorMap.outPeak,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.outPeak),
      },
      {
        name: $str.getKey('收益管理/放电') + '（' + $str.getKey('收益管理/平') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/放电'),
        color: segmentsColorMap.outFlat,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.outFlat),
      },
      {
        name: $str.getKey('收益管理/放电') + '（' + $str.getKey('收益管理/谷') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/放电'),
        color: segmentsColorMap.outValley,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.outValley),
      },
      {
        name: $str.getKey('收益管理/放电') + '（' + $str.getKey('收益管理/深') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/放电'),
        color: segmentsColorMap.outDeepValley,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.outDeepValley),
      },
      // 充电 ------
      {
        name: $str.getKey('收益管理/充电') + '（' + $str.getKey('收益管理/尖') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/充电'),
        color: segmentsColorMap.inSharp,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.inSharp),
      },
      {
        name: $str.getKey('收益管理/充电') + '（' + $str.getKey('收益管理/峰') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/充电'),
        color: segmentsColorMap.inPeak,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.inPeak),
      },
      {
        name: $str.getKey('收益管理/充电') + '（' + $str.getKey('收益管理/平') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/充电'),
        color: segmentsColorMap.inFlat,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.inFlat),
      },
      {
        name: $str.getKey('收益管理/充电') + '（' + $str.getKey('收益管理/谷') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/充电'),
        color: segmentsColorMap.inValley,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.inValley),
      },
      {
        name: $str.getKey('收益管理/充电') + '（' + $str.getKey('收益管理/深') + '）',
        type: "bar",
        stack: $str.getKey('收益管理/充电'),
        color: segmentsColorMap.inDeepValley,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.inDeepValley),
      },
    ];
  }
  if (incomeModel === 2) {
    series = [
      {
        name: $str.getKey('收益管理/充电'),
        type: "bar",
        color: segmentsColorMap.inSum,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.inSum),
      },
      {
        name: $str.getKey('收益管理/放电'),
        type: "bar",
        color: segmentsColorMap.outSum,
        barMaxWidth: 6, // 参考收益统计图的柱子粗细
        data: chartData.map(p => p.outSum),
      },
    ]
  }
  return series;
}



function createTooltip(config={}) {
  return {
    show: true,
    z: 1000000111,
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    // tips 背景色改为与主页面一致
    backgroundColor: '#ffffff',
    borderColor: 'rgba(15, 23, 42, 0.06)',
    // 鼠标移走后立即隐藏
    hideDelay: 0,
    enterable: false,
    formatter(params) {
      if (params.length > 0) {
        const firstItem = params[0];
        const time = firstItem.name;

        // 分离充电和放电数据
        const chargeItems = []; // 充电数据
        const dischargeItems = []; // 放电数据
        
        params.forEach(item => {
          const seriesName = item.seriesName || '';
          if (seriesName.includes($str.getKey('收益管理/充电')) || seriesName.includes('充电')) {
            chargeItems.push(item);
          } else if (seriesName.includes($str.getKey('收益管理/放电')) || seriesName.includes('放电')) {
            dischargeItems.push(item);
          }
        });

        // 生成充电数据HTML
        let chargeHtml = '';
        chargeItems.forEach(item => {
          chargeHtml += `
              <div class="chart-tooltip__series">
                <div class="chart-tooltip__point" style="background: ${item.color}"></div>
                <div class="chart-tooltip__series-name">${item.seriesName}: </div>
                <div class="chart-tooltip__value">${item.value} kWh</div>
              </div>
          `
        });

        // 生成放电数据HTML
        let dischargeHtml = '';
        dischargeItems.forEach(item => {
          dischargeHtml += `
              <div class="chart-tooltip__series">
                <div class="chart-tooltip__point" style="background: ${item.color}"></div>
                <div class="chart-tooltip__series-name">${item.seriesName}: </div>
                <div class="chart-tooltip__value">${item.value} kWh</div>
              </div>
          `
        });

        const htmlText = `
            <div class="chart-tooltip__time">${$str.getKey('收益管理/时间')}: ${time}</div>
            <div class="chart-tooltip__items-container kwh-20250222">
              <div class="chart-tooltip__charge-container">
                ${chargeHtml}
              </div>
              <div class="chart-tooltip__discharge-container">
                ${dischargeHtml}
              </div>
            </div>
        `

        return htmlText; /* html */
      }
      return `<div class="chart-tooltip__items-container">${$str.getKey('全局/暂无数据')}</div>`
    }
  }
}


